<template>
    <div class="inline-block">
        <Icons.TITrue class="ml-2 items-start fill-current text-green-700" v-if="props.value" title="Yes"></Icons.TITrue>
        <Icons.TIFalse class="ml-2 items-start fill-current text-red-700" v-else title="No"></Icons.TIFalse>
    </div>
</template>

<script setup>
import Icons from '../../Icons.js';

const props = defineProps({
    value: Boolean,
});
</script>
